function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFlagOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M27.984 17.377l-2.3-12.711c-.089-.502-.543-.825-1.032-.73l-5.11.942c-.46.092-.905-.225-.994-.702a2.732 2.732 0 00-1.075-1.71 2.513 2.513 0 00-1.96-.416L4.729 4.057a.954.954 0 00-.568.36.91.91 0 00-.143.696L8.708 29.27c.093.42.454.724.86.724h.147l.027-.006a.88.88 0 00.588-.396.838.838 0 00.098-.66L8.396 18.436l9.708-1.89a.833.833 0 01.636.138.89.89 0 01.358.563c.132.7.517 1.305 1.087 1.706a2.526 2.526 0 001.947.423l5.125-.946c.507-.128.818-.581.728-1.053zm-9.275-2.619a2.651 2.651 0 00-.424-.03c-.152 0-.299 0-.475.036l-9.74 1.89-2.124-10.99 9.92-1.832a.804.804 0 01.627.128c.189.143.32.353.365.572l1.854 10.226h-.003zm7.409 2.038l-4.273.797a.83.83 0 01-.636-.137.89.89 0 01-.359-.56L19.023 6.68c.301.049.6.043.872-.015l4.246-.797 1.983 10.93h-.006z",
    fill: props.color
  }));
}

export default SvgIconFlagOutline;